import { MemberInfiniteListParams, MemberListParams, memberMutations, memberQueries } from '@entities/Member/queries';
import { MemberFront } from '@entities/Member/types';
import { PaginatedResponse } from '@root/src/types/common';

import {
  useQuery,
  UseQueryResult,
  useInfiniteQuery,
  UseInfiniteQueryResult,
  InfiniteData,
  useMutation,
  UseMutationResult,
} from '@tanstack/react-query';

export const useMembers = (options: MemberListParams = {}): UseQueryResult<PaginatedResponse<MemberFront>, Error> =>
  useQuery(memberQueries.list(options));

/**
 * Hook for infinite scrolling of members data. Loads members page by page as the user scrolls,
 * maintaining a cache of loaded data to avoid unnecessary requests
 * https://tanstack.com/query/latest/docs/framework/react/guides/infinite-queries
 */
export const useMembersInfinite = (
  options?: MemberInfiniteListParams,
): UseInfiniteQueryResult<InfiniteData<PaginatedResponse<MemberFront>>, Error> =>
  useInfiniteQuery(memberQueries.infiniteList({ filters: options?.filters }));

export const useMember = (id?: string): UseQueryResult<MemberFront, Error> => useQuery(memberQueries.detail(id ?? ''));

export const useDeleteMember = (): UseMutationResult<void, Error, string> => useMutation(memberMutations.delete());
